var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.9934V26.9956L28.5677 28.9906V15.0059L19.9881 9.99656L11.4041 15.0059L11.4258 28.9972L8 26.9956V13.0044L20.0097 6L32 12.9934ZM21.7096 28.9906L19.9989 29.9969L18.2774 29.0016V15.0059L14.8516 17.0075L14.8581 30.9987L19.9946 34L25.1419 30.9987V17.0009L21.7096 14.9994V28.9906Z",
    fill: "#F26322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagento);
export default __webpack_public_path__ + "static/media/magento.00cce0a4d41031ce45fb1a360584ba3b.svg";
export { ForwardRef as ReactComponent };